module.exports = __webpack_public_path__ + "assets/img/title-92ca592a.png";